import { createAction, props } from '@ngrx/store';
import { PromptTypes } from 'generated/graphql-types';
import { SingleGraphError } from 'src/app/common-components/errors/models/error-message';
import { AddTimeBasedRouteData } from '../../extension-time-based-routes/models/extension-time-based-routes.model';
import { VoiceMailGreetingPromptOption } from '../../mailbox-details/models/voicemail-greeting-prompt-option.model';
import { PromptOption } from '../../prompt-register/models/prompt-option.interface';
import { ExtensionHackedFraudDetails } from '../helpers/hacked-fraud-helper';
import { ExtensionDetailSaveEvent } from '../models/extension-detail-form-submit-event';
import { ExtensionDetailView, ExtensionNumberDetail } from '../models/extension-detail-view.model';
import {
   GetExtensionDetail_extension,
   GetExtensionDetail_extension_mailbox,
} from '../queries/generated/GetExtensionDetail';
import { SaveExtension } from '../queries/generated/SaveExtension';
import { AddFindMeFollowMeStepData } from '../views/extension-find-me-follow-me-sections/models/extension-find-me-follow-me-step.model';

export const extensionDetailLoad = createAction('[Extension Detail] Load');

export const extensionDetailCancel = createAction('[Extension Detail] Cancel');

export const loadExtensionDetailSuccess = createAction(
   '[API] Load Extension Success',
   props<{ data: GetExtensionDetail_extension }>()
);

export const loadExtensionDetailFailure = createAction('[API] Load Extension Failure', props<SingleGraphError>());

export const loadExternalNumbersSuccess = createAction('[API] Load External Numbers Success', props<{ data: any }>());

export const loadExternalNumbersFailure = createAction(
   '[API] Load External Numbers Failure',
   props<SingleGraphError>()
);

export const saveExtensionDetail = createAction('[Extension Detail] Save', props<ExtensionDetailSaveEvent>());

export const saveExtensionDetailSuccess = createAction(
   '[Extension Detail] Save Success',
   props<{ data: SaveExtension }>()
);

export const loadExtensionAccessDenied = createAction('[Extension Detail] Access Denied');

export const saveExtensionDetailFailure = createAction('[Extension Detail] Save Failure', props<SingleGraphError>());

export const deleteExtension = createAction(
   '[Extension Detail] Delete Extension',
   props<{
      extensionId: number;
      number: number;
      autoAttendantsUsingForTimeout?: ExtensionDetailView[];
      fmFmsUsingForFinalDestination?: ExtensionDetailView[];
      timeBasedRoutesUsingForRoute?: ExtensionDetailView[];
      queuesUsingForExitRoute?: ExtensionDetailView[];
      huntGroupsUsingForRouteBusy?: ExtensionDetailView[];
      huntGroupsUsingForRouteNoAnswer?: ExtensionDetailView[];
   }>()
);

export const deleteExtensionSuccess = createAction(
   '[Extension Detail] Delete Extension Success',
   props<{ number: number }>()
);

export const deleteExtensionFailure = createAction(
   '[Extension Detail] Delete Extension Failure',
   props<SingleGraphError>()
);

export const addExistingPrompt = createAction(
   '[Extension Detail] Add Existing Prompt',
   props<{ promptTypes: PromptTypes[] }>()
);

export const addNewPrompt = createAction(
   '[Extension Detail] Add New Prompt',
   props<{ promptType: PromptTypes; voiceMailGreetingPrompt: VoiceMailGreetingPromptOption | null }>()
);

export const addNewTimeBasedRoute = createAction('[Extension Detail] Add New Time Based Route');

export const addNewFindMeFollowMeStep = createAction('[Extension Detail] Add New Find Me Follow Me Step');

export const findMeFollowMeStepSubmit = createAction(
   '[Extension Detail FmFm Step Dialog] Submit',
   props<{ findMeFollowMeStepItem: AddFindMeFollowMeStepData }>()
);

export const promptItemDialogSubmit = createAction(
   '[Extension Detail Prompt Dialog] Submit',
   props<{ promptItem: PromptOption }>()
);

export const editMailboxPin = createAction('[Extension Detail] Edit Mailbox Pin');

export const changeDNDStatus = createAction(
   '[Extension Detail] Change DND Status',
   props<{ dndStatus: string | null }>()
);

export const changeDNDStatusSuccess = createAction(
   '[Extension Detail] Change DND Status Success',
   props<{ dndStatus: string | null }>()
);

export const logAgentOutOfQueue = createAction(
   '[Extension Detail] Log Agent Out Of Queue',
   props<{ queueMemberId: number; extensionName: string }>()
);

export const logAgentOutOfQueueSuccess = createAction(
   '[Extension Detail] Log Agent Out Of Queue Success',
   props<{ extensionName: string }>()
);

export const timeBasedRouteItemDialogSubmit = createAction(
   '[Extension Detail Route Dialog] Submit',
   props<{ timeBasedRouteItem: AddTimeBasedRouteData }>()
);

export const loadExtensionMailbox = createAction('[Extension Detail] Load Extension Mailbox Messages');

export const loadExtensionMailboxSuccess = createAction(
   '[Extension Detail] Load Extension Mailbox Messages Success',
   props<{ mailbox: GetExtensionDetail_extension_mailbox }>()
);

export const loadExtensionMailboxFailure = createAction(
   '[Extension Detail] Load Extension Mailbox Messages Failure',
   props<SingleGraphError>()
);
export const uploadMohPrompt = createAction('[Extension Detail] Create MOH Prompt');

export const uploadCallbackPrompt = createAction('[Extension Detail] Create Callback Prompt');

export const changeSipUserPassword = createAction(
   '[Extension Detail] Change Sip User Password',
   props<{ sipUserIds: number[] }>()
);

export const changeSipUserPasswordSuccess = createAction('[Extension Detail] Change Sip User Password Success');

export const changeSipUserPasswordFailure = createAction(
   '[Extension Detail] Change Sip User Password Failure',
   props<SingleGraphError>()
);

export const getHackedFraudDetailsSuccess = createAction(
   '[Extension Detail] Get Hacked Fraud Details Success',
   props<{ details: ExtensionHackedFraudDetails }>()
);

export const loadAccountExtensionsSuccess = createAction(
   '[API] Load Account Extensions Success',
   props<{ data: ExtensionNumberDetail[] }>()
);

export const resetMwi = createAction(
   '[Mailbox] Reset Mailbox MWI',
   props<{ accountId: number | undefined; extensionId: number | undefined }>()
);

export const resetMwiConfirmation = createAction(
   '[Mailbox] Reset Mailbox MWI Confirmation',
   props<{ accountId: number | undefined; extensionId: number | undefined }>()
);

export const resetMwiCancel = createAction('[Mailbox] Reset Mailbox MWI Cancelled');

export const resetMwiSuccess = createAction('[Mailbox] Reset Mailbox MWI Success');

export const resetMwiFailure = createAction('[Mailbox] Reset Mailbox MWI Failure');

export const navigate = createAction(
   '[Extension Detail] Navigate',
   props<{
      id: number | string;
      extensionNumbersWithTypes: ExtensionNumberDetail[];
   }>()
);
